import { CompozzError, isCompozzError } from "@dto/CompozzError";
import { UserPreferences } from "@dto/preferences";
import { saveObjectPreferences } from "@utils/preferencesApi";
import { toastError } from "@utils/toasts";
import { FolderData } from "@utils/viewFolders";
import { useTranslation } from "react-i18next";
import { translate } from "src/i18n/i18n";
import { useModelStore } from "src/store";

/**
 * Personal view folders of one object: current preferences + the single save
 * path (PUT of the whole document, store updated with the normalized document
 * returned by the backend; errors are toasted, the state stays unchanged).
 */
export function useViewFolders(objectKey: string) {
    const { t } = useTranslation();
    const workspace = useModelStore(state => state.selectedWorkspace);
    const prefs = useModelStore(state => state.viewPreferencesByObjectKey.get(objectKey));
    const setObjectPreferences = useModelStore(state => state.setObjectPreferences);

    const saveFolders = async (data: FolderData): Promise<boolean> => {
        if (!workspace?._key) {
            console.error("Workspace key is not set");
            return false;
        }
        const response = await saveObjectPreferences(workspace._key, objectKey, {
            viewFolders: data.viewFolders,
            viewsByFolder: data.viewsByFolder,
        });
        if (response && isCompozzError(response)) {
            const cError = response as CompozzError;
            if (cError.i18n) {
                toastError(translate(t, cError.i18n, cError.params));
            } else {
                toastError(cError.message);
            }
            return false;
        }
        if (response) {
            setObjectPreferences(objectKey, response as UserPreferences);
            return true;
        }
        return false;
    };

    return { prefs, saveFolders };
}
